import {Box} from 'platform/foundation';
import styled, {css} from 'styled-components';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {OptionStatusIndicator} from '../../../types/OptionTypeBase';
import {Tooltip} from '../../Tooltip/Tooltip';

// Option content is wrapped in pointer-events: none (see components.tsx, T20-22340);
// the dot needs its own pointer events so the tooltip can open on hover.
const HoverableWrapper = styled.span<{
  $isOverAvatar?: boolean;
}>`
  pointer-events: auto;
  display: inline-flex;
  ${({$isOverAvatar}) =>
    $isOverAvatar &&
    css`
      position: absolute;
      right: 0;
      bottom: 0;
    `}
`;

type StatusIndicatorDotProps = {
  statusIndicator: OptionStatusIndicator | Nullish;
  isOverAvatar?: boolean;
};

export function StatusIndicatorDot(props: StatusIndicatorDotProps) {
  if (isNil(props.statusIndicator)) {
    return null;
  }

  const dot = (
    <Box
      width={2}
      height={2}
      borderRadius="circular"
      border="1px solid"
      borderColor="general.white"
      backgroundColor="palettes.red.70.100"
    />
  );

  return (
    <HoverableWrapper data-testid="status-indicator-dot" $isOverAvatar={props.isOverAvatar}>
      {props.statusIndicator.tooltip ? (
        <Tooltip label={props.statusIndicator.tooltip} isInteractive>
          {dot}
        </Tooltip>
      ) : (
        dot
      )}
    </HoverableWrapper>
  );
}
